import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/* Import required components */
import { ProjectmanagementComponent } from './projectmanagement/projectmanagement.component';
import { AddnewprojectComponent } from './projectmanagement/projectadd/addnewproject.component';
import { ProjectoverviewComponent } from './projectmanagement/projectoverview/projectoverview.component';
import { PaschooladminComponent } from './projectsetup/paschooladmin/paschooladmin.component';
import { SchooladdComponent } from '../../../schoolmanagement/src/app/schooladd/schooladd.component';
import { SchooloverviewComponent } from '../../../schoolmanagement/src/app/schooloverview/schooloverview.component';
import { SetupYourSchoolComponent } from '../../../schoolmanagement/src/app/setupyourschool/setupyourschool.component';
/* Import auth guard service */
import { AuthGuard } from '../../../../src/app/auth/auth.guard';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'projectmanagement',
    pathMatch: 'full'
  },
  { path: 'projectmanagement',
    component: ProjectmanagementComponent,
    canActivate: [AuthGuard],
  },
  { path: 'projectmanagement/addproject',
    component: AddnewprojectComponent,
    canActivate: [AuthGuard],
  },
  { path: 'projectmanagement/:project_id',
    children: [
        { path: 'view', component: ProjectoverviewComponent, canActivate: [AuthGuard] },
        { path: 'setup', component: PaschooladminComponent, canActivate: [AuthGuard]},
        { path: 'addschool', component: SchooladdComponent, canActivate: [AuthGuard]},
        {path: ':school_id',
          children: [
            {path: 'view', component: SchooloverviewComponent },
            { path: 'setup',    component: SetupYourSchoolComponent}
          ]
        }
    ]
  },
  {
    path: '**',
    redirectTo: '404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
